
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import GetStartedHero from './components/GetStartedHero';
import WhatHappensNext from './components/WhatHappensNext';
import TimeExpectation from './components/TimeExpectation';
import FormSection from './components/FormSection';
import FinalReassurance from './components/FinalReassurance';
import SEOHead from '../../components/SEOHead';

export default function GetStartedPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Get Started — Free Automation Plan for Long Island Businesses',
    description: 'Tell us about your business and get a free automation plan. See how Automigo can help your Long Island service business respond instantly to customer inquiries.',
    url: `${siteUrl}/get-started`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Get Started', item: `${siteUrl}/get-started` }
      ]
    }
  };

  return (
    <>
      <SEOHead
        title="Get Started - Automigo | Free Automation Plan for Long Island Businesses"
        description="Tell me about your business and get a free automation plan. See how Automigo can help your Long Island service business respond instantly to customer inquiries and win more jobs."
        keywords="get started, automation plan, Long Island business automation, service business automation, customer response automation"
        canonical={`${siteUrl}/get-started`}
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <GetStartedHero />
        <WhatHappensNext />
        <TimeExpectation />
        <FormSection />
        <FinalReassurance />
        <Footer />
      </div>
    </>
  );
}
